import React from 'react';
import '../../assets/scss/projectTable.scss';
import { withRouter } from '../../services/withRoute';
import { ReactComponent as LinkIcon } from '../../assets/svg/external-link.svg';
import moment from 'moment';
import _ from 'lodash';

class McListTableRow extends React.Component {
	goToShoot = (e, workspaceID, projectID, shootID) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${workspaceID}/${projectID}/${shootID}`,
		);
	};
	getWorkspacekey = (name) => {
		if (this.props.workSpaceFilters.length !== 0) {
			for (let i = 0; i < this.props.workSpaceFilters.length; i++) {
				if (this.props.workSpaceFilters[i].key === name) {
					return this.props.workSpaceFilters[i].workspaceKey;
				}
			}
		}
		return ' ';
	};

	render() {
		return (
			<tr
				height={40}
				onClick={() => {
					this.props.navigate(
						`/${this.props.params.vendorID}/memory-cards/${this.props.data.qrCode}`,
					);
				}}

				// this.props.navigate(`/${this.props.params.vendorID}/harddrives/assign`);
			>
				<td>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div>
							{_.has(this.props.data, 'qrCode') && this.props.data.qrCode ? (
								<>
									<div style={{ fontSize: '14px' }}>
										{this.props.data.qrCode}
										{/* {this.props.data.qrCode.slice(3, 5)} */}
									</div>
									{/* <div >
                                        <span
                                            className="date"
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                            }}
                                        >
                                            {this.props.data.qrCode.slice(5)}
                                        </span>
                                    </div> */}
								</>
							) : null}
						</div>
					</div>
				</td>
				<td>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div>
							<div style={{ fontSize: '14px' }}>
								{this.props.data.type === 'SD'
									? 'SD'
									: this.props.data.type === 'SSD'
									? 'SSD'
									: this.props.data.type === 'SSDmini'
									? 'SSD Mini'
									: this.props.data.type === 'SDDmini'
									? 'SDD Mini'
									: this.props.data.type === 'SDHC'
									? 'SDHC'
									: this.props.data.type === 'XQD'
									? 'XQD'
									: this.props.data.type === 'MicroSD'
									? 'Micro SD'
									: this.props.data.type === 'ToughSD'
									? 'Tough SD'
									: ''}{' '}
								-
								{_.has(this.props.data, 'size') && this.props.data.size
									? ` ${this.props.data.size}`
									: ' -'}
							</div>
							{/* <div className="upper-wed">
                                <span
                                    className="date"
                                    style={{ width: '100%', display: 'flex' }}
                                >
                                    {_.has(this.props.data, 'size') &&
                                    this.props.data.size
                                        ? `${this.props.data.size}`
                                        : '-'}
                                </span>
                            </div> */}
						</div>
					</div>
				</td>
				<td
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					{/* <div className="project-general-box"> */}
					<span
						className={`completed-shoots `}
						style={{
							// marginTop: '-120px',

							display: 'flex',
							// justifyContent: 'flex-start',
							alignItems: 'center',
							textTransform: 'uppercase',
							fontSize: '14px',
						}}
					>
						<b
							style={{
								width: '10px',
								height: '10px',
								minHeight: '10px',
								minWidth: '10px',
								borderRadius: '2px',
								backgroundColor:
									this.props.data.status === 'ready'
										? '#479A5F'
										: this.props.data.status === 'busy'
										? '#CA5A4F'
										: this.props.data.status === 'backupPending'
										? '#CA5A4F'
										: this.props.data.status === 'verificationPending'
										? '#CA5A4F'
										: this.props.data.status === 'formatPending'
										? '#CA5A4F'
										: 'transparent',
								marginRight: 5,
								display: 'flex',
							}}
						></b>
						{this.props.data.status === 'ready'
							? 'READY'
							: this.props.data.status === 'busy'
							? 'BUSY'
							: this.props.data.status === 'backupPending'
							? 'BUSY'
							: this.props.data.status === 'verificationPending'
							? 'BUSY'
							: this.props.data.status === 'formatPending'
							? 'BUSY'
							: ''}
						{/* <p>{this.props.data.status}</p> */}
					</span>
					<p style={{ color: '#707070' }}>
						{this.props.data.subStatus
							? this.props.data.subStatus.charAt(0).toUpperCase() +
							  this.props.data.subStatus.replace(/([A-Z])/g, ' $1').slice(1)
							: ''}
						{/* {this.props.data.subStatus.charAt(0).toUpperCase() +
                            this.props.data.subStatus
                                .replace(/([A-Z])/g, ' $1')
                                .slice(1)} */}
					</p>
					{/* </div> */}
				</td>
				{this.props.data.status === 'ready' || this.props.data.status === '' ? (
					<>
						<td className="wedding-details-column"></td>
						<td className="wedding-details-column"></td>
						<td className="wedding-details-column"></td>
					</>
				) : (
					<>
						{/* <td className="wedding-details-column">
                            <div
                                style={{
                                    height: '100%',
                                    position: 'relative',
                                }}
                            >
                                <div className="wedding-details wedding-details-center">
                                    <div className="upper-wed">
                                        <span
                                            className="date"
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                            }}
                                        >
                                            {this.props.data.status !== 'ready'
                                                ? this.props.data.lastUsedBy &&
                                                  _.has(
                                                      this.props.data
                                                          .lastUsedBy,
                                                      'workspaceId'
                                                  ) &&
                                                  this.props.data.lastUsedBy
                                                      .workspaceId
                                                    ? this.props.data.lastUsedBy
                                                          .workspaceId
                                                    : ''
                                                : ''}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </td> */}
						<td>
							<div
								style={{
									height: '100%',
									position: 'relative',
								}}
							>
								<div>
									<div
										style={{
											fontSize: '14px',
											width: '200px',
										}}
									>
										{'(' +
											(_.has(this.props.data.lastUsedBy, 'workspaceId') &&
											this.props.data.lastUsedBy.workspaceId
												? this.props.data.lastUsedBy.workspaceId
												: '')}{' '}
										{' - ' +
											(_.has(this.props.data.lastUsedBy, 'eventSlNo') &&
											this.props.data.lastUsedBy.eventSlNo
												? this.props.data.lastUsedBy.eventSlNo
												: '') +
											')'}
										{_.has(this.props.data.lastUsedBy, 'projectName') &&
										this.props.data.lastUsedBy.projectName
											? this.props.data.lastUsedBy.projectName
											: ''}
									</div>
								</div>
								<div>
									<div>
										<span
											style={{
												fontSize: '14px',
												color: '#B0B0B0',
											}}
										>
											{this.props.data.lastUsedBy &&
											_.has(this.props.data.lastUsedBy, 'eventName') &&
											this.props.data.lastUsedBy.eventName
												? this.props.data.lastUsedBy.eventName
												: ''}
										</span>
										{this.props.data.lastUsedBy !== null ? (
											<span
												className="external-link"
												onClick={(e) => {
													e.stopPropagation();
													this.goToShoot(
														e,
														this.props.data.lastUsedBy.workspaceId,
														this.props.data.lastUsedBy.projectId,
														this.props.data.lastUsedBy.eventId,
													);
												}}
											>
												<LinkIcon />
											</span>
										) : null}
									</div>
								</div>
							</div>
						</td>
						<td>
							<div
								style={{
									height: '100%',
									position: 'relative',
									fontSize: '14px',
								}}
							>
								<div>
									<span
										// className="date"
										style={{
											width: '100%',
											display: 'flex',
											fontSize: '14px',
										}}
									>
										{this.props.data.lastUsedBy &&
										_.has(this.props.data.lastUsedBy, 'userName') &&
										this.props.data.lastUsedBy.userName
											? this.props.data.lastUsedBy.userName
											: '-'}
									</span>
								</div>
								<p
									style={{
										color: '#707070',
									}}
								>
									{this.props.data.lastUsedBy &&
									_.has(this.props.data.lastUsedBy, 'usedAt') &&
									this.props.data.lastUsedBy.usedAt
										? moment
												.unix(this.props.data.lastUsedBy.usedAt)
												.format('DD MMM YYYY, h:mma')
										: ''}
								</p>
							</div>
						</td>
					</>
				)}
			</tr>
		);
	}
}

export default withRouter(McListTableRow);
